/** 基础数据相关 */
import { get, post, postByJson,download, A_URL ,STATISTICS_URL} from './https.js';
// 通过excel导入学生url
const ADD_STU_BY_EXCEL_URL = A_URL + "a0004/addByExcel";

export default {
    ADD_STU_BY_EXCEL_URL,
    /** a0001:学校相关功能 */
    // 获取盒子内学校信息，激活后盒子学校信息只有一条数据
    getSchoolListForActive() { return get(A_URL + "a0001/list/for/active"); },

    /** a0002:教师相关功能 */
    // 获取盒子内教师信息，盒子内教师数据量不大，不需要分页处理
    getTeacherListForActive() { return get(A_URL + "a0002/list/for/active"); },
    // 修改教师密码
    updateTeacherPasswd(param) { return post(A_URL + 'a0002/update/passwd', param); },
    // 重置教师密码
    resetPassword(id) { return post(A_URL + 'a0002/reset/password', { id: id });},
    // 闯关得分率设置
    passRateSetting(){
        return get(A_URL + "a0002/rush/setting");
    },
    savePassRate(param){
        return get(A_URL + "a0002/rush/setting/passRate",param);
    },

    /** a0003:班级相关功能 */
    // 获取当前用户的所有班级
    listUserCls() { return get(A_URL + "a0003/cls/user/list"); },
    //获取当前用户发送的所有班级
    listSendUserCls(param){return get(A_URL + "a0003/cls/user/listSendUserCls",param);},
    // 获取当前用户的临时班级
    listUserClsByType() { return get(A_URL + "a0003/cls/user/list/type"); },
    // 获取当前用户的加入班级
    listUserJoinCls() { return get(A_URL + "a0003/joinClass/user/list"); },
    // 新增班级信息
    addCls(param) { return post(A_URL + "a0003/cls/add", param); },
    // 修改班级信息
    updateCls(param) { return post(A_URL + "a0003/cls/update", param); },
    // 删除班级信息
    deleteCls(param) { return post(A_URL + "a0003/cls/delete", param); },
    // 获取院系信息
    getDepts(param) { return get(A_URL + "a0003/dept/user/list", param); },
    // 获取专业信息
    getMajor(param) { return get(A_URL + "a0003/major/user/list", param); },
    // 获取班级信息
    listClassByMajorAndYear(param) { return get(A_URL + "a0003/joinClass/user/listClassByMajorAndYear", param); },
    // 新增班级信息
    addJoinCls(param) { return post(A_URL + "a0003/class/joinClass", param); },
    // 设置班主任
    setTeacher(param) { return post(A_URL + "a0003/class/setTeacher", param); },
    // 解除班主任
    relieveTeacher(param) { return post(A_URL + "a0003/class/relieveTeacher", param); },
    // 退出班级
    outJoinCls(param) { return post(A_URL + "a0003/class/outJoinClass", param); },

    /** a0004:学生相关功能 */
    // 新增学生
    addStu(param) { return post(A_URL + "a0004/add", param); },
    // 修改学生
    editStu(param) { return post(A_URL + "a0004/edit", param); },
    // 通过头像添加学生
    addStuByHead(param) { return postByJson(A_URL + "a0004/addByHead", param); },
    // 新增学生
    listStu(param) { return get(A_URL + "a0004/listStudent", param); },
    // 删除学生
    deleteStu(param) { return post(A_URL + "a0004/delete", param); },
    // 删除学生
    deleteStuList(param) { return postByJson(A_URL + "a0004/deleteList", param); },
    // 重置学生密码
    resetStuPasswd(param) { return post(A_URL + "a0004/resetPasswd", param); },
    // 创建分组
    groupStu(param) { return post(A_URL + "a0004/group/create", param); },
    // 分组列表
    listGroup(param) { return get(A_URL + "a0004/group/list", param); },
    // 删除全部分组
    deleteAllGroup(param) { return post(A_URL + "a0004/group/del/all", param); },
    // 删除单个分组
    deleteSingleGroup(param) { return post(A_URL + "a0004/group/del/by/id", param); },
    // 编辑小组名称
    editGroupName(param) { return post(A_URL + "a0004/group/edit/name", param); },
    // 组间人员移动
    moveGroupStu(param) { return post(A_URL + "a0004/group/move/stu", param); },
    // 设置小组组长
    setTeamLeader(param) { return post(A_URL + "a0004/group/set/leader", param); },

    /** a0004:留言相关功能 */
    // 教师发送留言
    addMessage(param){ return postByJson(A_URL + 'a0004/addMessage', param)},
    // 获取留言学生列表
    listStudentByTeacherId(teacherId) { return post(A_URL + 'a0004/listStudentByTeacherId', { teacherId: teacherId });},
    // 获取学生留言内容
    listStudentMessageContent(param) { return postByJson(A_URL + "a0004/listStudentMessageContent", param); },
    // 获取学生留言总数量
    messageContentCount(param) { return postByJson(A_URL + "a0004/messageContentCount", param); },
    // 获取教师收到的留言
    userMessageCount(teacherId) { return post(A_URL + "a0004/userMessageCount", { teacherId: teacherId });},
    // 获取当前学生未读消息数量
    noReadMessageCount(param) { return postByJson(A_URL + "a0004/noReadMessageCount", param); },
    // 导出班级学生使用数据
    exportClassUsedData(param) {return download(STATISTICS_URL + "classData/exportClassUsedData",param)},
    // 获取当前用户学校的所有课程和公共课程
    listSchoolCourse() {return get(STATISTICS_URL + "classData/courseList")},
    // 获取当前用户所有班级
    classList(param) {return get(STATISTICS_URL +"classData/classList")},
   // 获取当前班级所有学生
    studentClassInfoList(param) {
      return get(STATISTICS_URL + "classData/studentList",param) },
   //获取当前用户所有教学设计
    tdList(param) {
    return get(STATISTICS_URL + "classData/tdList?courseId=" +  param ) },
   // 获取学生信息
    studentInfo(param) {
      return get(STATISTICS_URL + 'classData/getStudentInfo?id='+ param)
    },
   // 获取学生任务信息
  getStudentLessonInfo(param) {
    return get(STATISTICS_URL + 'classData/studentInfoInLesson',param)
  },
    // 获取学生自学数据
    getSelfTaughtStudentList(param) {
        return get(STATISTICS_URL + 'classData/selfTaughtStudentList',param)
    },
    getSelfTaughtStudent(param) {
        return get(STATISTICS_URL + 'classData/selfTaughtStudent',param)
    },
    // 获取教师相关教材
    studyCourseList() {
        return get(STATISTICS_URL + 'classData/studyCourseList')
    },
    // 获取教材下学生闯关信息
    studyRushList(param){
        return get(STATISTICS_URL + 'classData/studyRushList',param)
    },
    // 获取学生学习包课程
    studentPayCourseList(id){
        return get(STATISTICS_URL + 'classData/studentPayCourseList',{studentId: id})
    }
}



// WEBPACK FOOTER //
// ./src/components/tools/request/https-a.js